import { HttpResponse } from 'msw'
import { restHandlerFactory } from 'src/tests/mocks/handlerFactory'

export const sendTestSMSHandler = restHandlerFactory(
  '/trials/{trial_uid}/explanation_patients/test_sms',
  'post',
  () => {
    return HttpResponse.json(undefined, { status: 204 })
  },
)
